"use strict";
// This utility depends on modals.js functionality, reference it BEFORE the modals.js!
var DEFAULT_RESTRICTION_TEXT = 'Unsupported web browser<br>\
    To access this, you should use a different web browser.<br>\
    Supported browsers include up-to-date versions of Google Chrome and Safari.';
var RESTRICT_IE_CLASS = 'restrict-ie';
// Determining if the browsers is IE (https://daily-dev-tips.com/posts/vanilla-javascript-browser-detection)
var IS_IE = /*@cc_on!@*/ false || !!document.documentMode;
document.addEventListener('DOMContentLoaded', function () {
    if (IS_IE) {
        var restrictElements = document.getElementsByClassName(RESTRICT_IE_CLASS);
        for (var i = 0; i < restrictElements.length; i++) {
            // Getting the modal text
            var modalText = restrictElements[i].getAttribute('data-restrict-text');
            // Replacing the modal text with the default if nothing is set
            if (!modalText || modalText.length === 0) {
                modalText = DEFAULT_RESTRICTION_TEXT;
            }
            // Defining and appending the modal to the body
            // Setting up the modal
            var modal = document.createElement('div');
            modal.classList.add('reveal-modal');
            // Setting up the modals close button
            var modalClose = document.createElement('a');
            modalClose.classList.add('close-reveal-modal');
            modalClose.innerHTML = '&#215;';
            var modalId = 'ieRestrictModal-' + i;
            modal.setAttribute('id', modalId);
            modal.innerHTML = modalText + modalClose.outerHTML;
            document.body.appendChild(modal);
            // Adding the ID to the element itself
            restrictElements[i].setAttribute('data-reveal-id', modalId);
        }
    }
});
